export const validatorErrors = {
    passwordFormat: 'Password Format',
    passwordMatch: 'Password Mismatch',
    passwordSame: 'Passwords Same',
    emailFormat: 'email',
    postalCodeFormat: 'Postal Code Format',
    maximumLength: 'maxlength',
    minimumLength: 'minlength',
    patternMatch: 'pattern',
    required: 'required',
    whiteSpace: 'White space',
    dateBoundary: 'Date Boundary',
    minimumValue: 'min',
    maximumValue: 'max'
};